export default "__VITE_ASSET__eirQTUJ0__"